export const SET_USERDATA = 'SET_USERDATA'

export const SET_LOADING = 'SET_LOADING'

export const SET_TAG = 'SET_TAG'

export const SET_TAGSTATUS = 'SET_TAGSTATUS'

export const SET_TOGGLEFLAG = 'SET_TOGGLEFLAG'

export const SET_STATECHANGE = 'SET_STATECHANGE'